import React from 'react';

const ProfileMenuWrapper = ({ children }) => {
    return <ul className='list-unstyled p-1'>{children}</ul>;
};

export default ProfileMenuWrapper;
